export default {
  REDUX_NAMESPACE: 'IULI/RECEIVABLES',

  SET_FILTER_COMPETENCY_DATE: 'RECEIVABLES/SET_FILTER_COMPETENCY_DATE',
  SET_FILTER_DUE_OR_PAYMENT_DATE: 'RECEIVABLES/SET_FILTER_DUE_OR_PAYMENT_DATE',
  SET_FILTER_COMPUTED_STATUS: 'RECEIVABLES/SET_FILTER_COMPUTED_STATUS',
  SET_FILTER_RECONCILED: 'RECEIVABLES/SET_FILTER_RECONCILED',
  SET_FILTER_CATEGORY_ID: 'RECEIVABLES/SET_FILTER_CATEGORY_ID',
  SET_FILTER_CATEGORIES_IDS: 'RECEIVABLES/SET_FILTER_CATEGORIES_IDS',
  SET_FILTER_BANK_ACCOUNTS_IDS: 'RECEIVABLES/SET_FILTER_BANK_ACCOUNTS_IDS',
  SET_FILTER_SOURCES: 'RECEIVABLES/SET_FILTER_SOURCES',
  SET_FILTER_PROJECTS: 'PAYABLES/SET_FILTER_PROJECTS',
  SET_FILTER_COST_CENTERS: 'PAYABLES/SET_FILTER_COST_CENTERS',
  SET_FILTER_TRANSACTIONS_IDS: 'PAYABLES/SET_FILTER_TRANSACTIONS_IDS',
  SET_FILTER_EXTERNALS_IDS: 'PAYABLES/SET_FILTER_EXTERNALS_IDS',
  SET_FILTERS: 'RECEIVABLES/SET_FILTERS',

  SET_SORT_MODEL: 'RECEIVABLES/SET_SORT_MODEL',

  SET_PAGE_SIZE: 'RECEIVABLES/SET_PAGE_SIZE',

  SET_INITIAL_STATE: 'RECEIVABLES/SET_INITIAL_STATE',
};
